import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*',
'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable()
export class UnverifiedAccountService {
    unverifyaccountUrl = '/superadmin/rest/mgmt/unverify/account';
    unverifyaccountCountUrl = '/superadmin/rest/mgmt/unverify/account/count?';
  constructor(private http: HttpClient) { }
  getUnverifyAccounts(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.unverifyaccountUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });

  }
  getTotalFilterCount(filter) {
    return this.http.get(this.unverifyaccountCountUrl + filter, {headers});
  }
}

